import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import WhenToReport from "@/components/site/WhenToReport";
import SocialMediaDSA from "@/components/site/SocialMediaDSA";
import WhyMatters from "@/components/site/WhyMatters";
import Process from "@/components/site/Process";
import Pricing from "@/components/site/Pricing";
import Testimonials from "@/components/site/Testimonials";
import CrossSell from "@/components/site/CrossSell";
import FAQ from "@/components/site/FAQ";
import ContactForm from "@/components/site/ContactForm";
import Footer from "@/components/site/Footer";
import WhatsAppFab from "@/components/site/WhatsAppFab";

export default function Home() {
  return (
    <div data-testid="home-page" className="min-h-screen bg-[#f5f1ea] text-[#2b2620] font-body">
      <Header />
      <main>
        <Hero />
        <WhenToReport />
        <WhyMatters />
        <Process />
        <Pricing />
        <Testimonials />
        <CrossSell />
        <SocialMediaDSA />
        <FAQ />
        <ContactForm />
      </main>
      <Footer />
      <WhatsAppFab />
    </div>
  );
}
